import { Box, Typography } from '@mui/material';
import { useId, type ReactNode } from 'react';
import { designTokens } from '../tokens';
import { DefinitionList, type DefinitionListItem } from './DefinitionList';
import type { InformationRowItem } from './InformationRow';
import { detailContentPadding } from './detailLayout';

export type DetailSectionRow = DefinitionListItem | InformationRowItem;

export type DetailSectionProps = {
  title: ReactNode;
  rows: readonly DetailSectionRow[];
};

export function DetailSection({ title, rows }: DetailSectionProps) {
  const titleId = useId();
  return <Box component="section" aria-labelledby={titleId} sx={detailContentPadding}>
    <Typography id={titleId} component="h3" sx={{ ...designTokens.typography.subsectionTitle, mb: `${designTokens.layout.informationRowGap}px` }}>{title}</Typography>
    <DefinitionList items={rows} />
  </Box>;
}
